import React from 'react'
import { useTranslation } from 'react-i18next'
/* LIB FUNCTIONS */
import { isPermission } from '../../lib/usePermission'
/* COMPONENTS */
import BPButton from '../../components/BPButton'

const ToolbarExportButton = ({ onClick, permission }) => {
  const { t } = useTranslation()
  if (permission && permission !== null) {
    return isPermission(permission) && (
      <BPButton type='button' label={t('export')} tooltip={t('export')} icon='cloud-download' className='bp3-intent-export' permission={permission} onClick={onClick} />
    )
  } else {
    return (
      <BPButton type='button' label={t('export')} tooltip={t('export')} icon='cloud-download' className='bp3-intent-export' onClick={onClick} />
    )
  }
}

export default ToolbarExportButton
